export * from './login.component';


// WEBPACK FOOTER //
// ./src/app/Components/login/index.ts